// Created by hejikun on 2017/11/2 0002.
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import vuexI18n from 'vuex-i18n'

import pTest from './test/plugin' // 这是一个测试插件，用于做一些功能测试，勿删
import Library from './library'
import Components from './components'
import Filters from './filters'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'animate.css'
import VueTouch from 'vue-touch'
import gallery from 'img-vuer'
import Vant from 'vant';
import 'vant/lib/index.css';
import * as Sentry from '@sentry/vue'

// import Aegis from 'aegis-web-sdk';
import hina from '/static/hina/hina.esm.min'
import { PageLeaveCollectUrlList } from '@/constant/ExtendedUrlList'
import { enrichSpecialDiseaseTrackData } from '@/utils/specialDiseaseTracking'
import { Toast } from 'vant';
Vue.use(Toast);
Vue.prototype.$Toast = Toast
Vue.config.productionTip = false
Vue.use(gallery, {
  swipeThreshold: 120 // default 100 ,new in 0.12.0
})

Vue.use(VueTouch, { name: 'v-touch' })
Vue.use(pTest)
Vue.use(Library)
Vue.use(Components)
Vue.use(Filters)
Vue.use(Mint)
Vue.use(Vant);
try {
  if(window.parent && window.location.pathname.indexOf('test-ticket')>0){
    window.parent.postMessage(JSON.stringify({ action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE' }),'https://payapp.weixin.qq.com')
  }
  
} catch (error) {
  
}

function loadVconsole() {
  if (/(localhost|192\.168|refactor-test)/.test(window.location.hostname)) {
    return import('vconsole').then(({ default: VConsole }) => {
      const vConsole = new VConsole()
      return vConsole
    })
  }
  if (localStorage.getItem("dev-mode-368bf4")==="4fb863") {
    return import('vconsole').then(({ default: VConsole }) => {
      const vConsole = new VConsole()
      return vConsole
    })
  }
  if (window.location.pathname === '/wechat/test-ticket') {
    return import('vconsole').then(({ default: VConsole }) => {
      const vConsole = new VConsole()
      return vConsole
    })
  }
  // if (window.location.href.indexOf('kunhua_physicalExamination') !== -1) {
  //   return import('vconsole').then(({ default: VConsole }) => {
  //     const vConsole = new VConsole()
  //   })
  // }
  return Promise.resolve()
}
// Sentry.init({
//   Vue,
//   dsn: 'https://1eec88b29587cc7413257d7f4a8f70b3@sentry.ynhdkc.com/3',
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: [ 'https://appv3-api.ynhdkc.com/'],
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router)
//     }),
//     new Sentry.Replay()
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

// const aegis = new Aegis({
//   id: 'r52JOulW4Reeo4KvWE', // 上报 id
//   reportApiSpeed: false, // 接口测速
//   reportAssetSpeed: false, // 静态资源测速
//   spa: true, // spa 应用页面跳转的时候开启 pv 计算
//   hostUrl: 'https://rumt-zh.com'
// });

const noticeUrl = 'https://appv3.ynhdkc.com/static/notice.html'
// const noticeUrl = 'http://localhost/static/notice.html'


function getCookie(cname) {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

function setCookie(cname, cvalue, exhours) {
  const d = new Date()
  d.setTime(d.getTime() + exhours * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

function needRedirect() {
  const ticket = getCookie('jMt2YqsSTEhnoqVIkANdohecNd5YMnk7')
  console.log(ticket)
  if (ticket !== 'jMt2YqsSTEhnoqVIkANdohecNd5YMnk7') {
    window.location.href = noticeUrl
  }
}

function randomString(len) {
  len = len || 32
  const $chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789' /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  const maxPos = $chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

function ticketPass() {
  const random = Math.random() * (101 - 1) + 1
  console.log('ticket random=' + random)
  setCookie('jMt2YqsSTEhnoqVIkANdohecNd5YMnk7', '1', 1)
  // if (random >= 75) {
  //   setCookie("jMt2YqsSTEhnoqVIkANdohecNd5YMnk7", "jMt2YqsSTEhnoqVIkANdohecNd5YMnk7", 24);
  // } else {
  //   setCookie("jMt2YqsSTEhnoqVIkANdohecNd5YMnk7", randomString(32), 1)
  //   window.location.href = noticeUrl
  // }
}

// if (getCookie("jMt2YqsSTEhnoqVIkANdohecNd5YMnk7")) {
//   needRedirect()
// } else {
//   ticketPass()
// }

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-subscribe']
const FastClick = require('fastclick')
FastClick.attach(document.body)

//解决ios需要多次点击问题
FastClick.prototype.focus = function (targetElement) {
  let length
  if (
    targetElement.setSelectionRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month'
  ) {
    length = targetElement.value.length
    targetElement.focus()
    targetElement.setSelectionRange(length, length)
  } else {
    targetElement.focus()
  }
}
FastClick.attach(document.body)

store.registerModule('i18n', vuexI18n)
Vue.use(vuexI18n.plugin, store)

sync(store, router)
sessionStorage.setItem('firstHref', window.location.href)
// 放开微信初始化方法，解决部分公众号入口页面和点击刷新页面后没有初始化jssdk的问题
window.utils.weixinInit()


// 如果用户未带path访问则跳转至首页
if (window.location.pathname === '/') {
  if (/(refactor-test|localhost)/.test(window.location.hostname)) {
    window.location.href = 'https://refactor-test.ynhdkc.com/home?channel=2'
  } else if (/(appv3-pre-production)/.test(window.location.hostname)) {
    window.location.href = 'https://appv3-pre-production.ynhdkc.com/home?channel=2'
  } else {
    window.location.href = 'https://appv3.ynhdkc.com/home?channel=2'
  }
}

loadVconsole()
// 用配置对象初始化 SDK
try {
  hina.init({
    // 配置采集上报地址URL
    serverUrl: 'https://higateway.haishuu.com/ha?project=DYT&token=FQ7ByZvt', // 配置采集上报地址URL（在线申请），查看如下【[采集上报地址获取] 链接
    showLog: true,
    // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 H_pageview 事件
    sendType: 'ajax',
    isSinglePage: true,
    autoTrackConfig: {
      // 是否开启自动点击采集, true表示开启，自动采集 H_WebClick 事件
      clickAutoTrack: false,
      // 是否开启页面停留采集, true表示开启，自动采集 H_WebStay 事件
      stayAutoTrack: true,
      collectTags: { div: true }
    }
  })
  //增加页面停留时间的采集
  hina.use('PageLeave', {
    custom_props: {
      leaveProp: 'leaveValue'
    },
    heartbeat_interval_time: 5,
    max_duration: 5 * 24 * 60 * 60,
    isCollectUrl: function (url) {
      const urlParsed = new URL(url)
      const path = urlParsed.pathname
      if (PageLeaveCollectUrlList.includes(path)) {
        console.log('页面浏览时长采集', path)
        return true
      }
      // url 为要采集页面浏览时长的页面地址。
      return false // 返回true为采集，false为不采集
    }
  })
  hina.quick('autoTrack')

} catch (error) {

}
//获取设备唯一ID
sessionStorage.setItem('hina_device_uid', hina.getDeviceUId())
//设置公共参数
hina.registerCommonProperties({
  channel: function () {
    if (window.__wxjs_environment === 'miniprogram') return 'miniprogram'
    return 'mp_h5'
  }
})
window.track_try_catch = (name, data = {}) => {
  hina.track(name, enrichSpecialDiseaseTrackData(name, data))
}

Vue.prototype.hina = hina
// loadVconsole()

// Vue.config.errorHandler = function(err, vm, info) {
//   console.log(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
//   aegis.error(`Error: ${err.toString()}\nStack: ${err.stack}\nInfo: ${info}`);
// };
//
// Vue.prototype.aegis = aegis

//添加 v-intersect 检测元素是否进入视图
Vue.directive('intersect', {
  inserted(el, binding) {
    const options = {
      root: null, // 视口
      rootMargin: '0px',
      threshold: 0.5 // 元素有 50% 出现在视图中时触发
    }

    const callback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('binding', binding)
          binding.value && binding.value() // 触发绑定的方法
          if (binding.modifiers.once) {
            observer.unobserve(el) // 取消观察，确保只触发一次
          }
        }
      })
    }

    const observer = new IntersectionObserver(callback, options)
    observer.observe(el)
  }
})
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
